import React from 'react';
import * as Styled from './ToggleFilter.styled'; 

export type FilterOption = 'All' | 'Free' | 'Premium';

interface ToggleFilterProps {
    selectedOption: any;
    onChange: any;
    options?: FilterOption[];
}

export const ToggleFilter: React.FC<ToggleFilterProps> = ({
    selectedOption,
    onChange,
    options = ['All', 'Free', 'Premium'],
}) => {
    const selectedIndex = options.indexOf(selectedOption);
    
    return (
        <Styled.ToggleContainer>
            <Styled.SlidingBackground selectedIndex={selectedIndex} totalOptions={options.length} />
            {options.map((option, index) => (
                <Styled.ToggleButton
                    key={option}
                    isSelected={selectedOption === option}
                    onClick={() => onChange(option)}
                >
                    {option}
                </Styled.ToggleButton>
            ))}
        </Styled.ToggleContainer>
    );
};
